// extracted by mini-css-extract-plugin
module.exports = {"fieldset":"CheckBox_fieldset__mgC06","checkbox":"CheckBox_checkbox__1Mti4","error":"CheckBox_error__dc1wM"};